var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"baocun"},[_c('van-button',{attrs:{"type":"warning"}},[_vm._v("长按图片进行保存")])],1),_c('div',{staticClass:"baocunimg"},[_c('img',{attrs:{"src":_vm.src,"width":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }